:host {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: var(--spacer-5);
}

slot {
  display: block;
}

slot[name='title']::slotted(*) {
  color: var(--theme-primary-text);
  font-size: 1.125rem !important;
  line-height: 1;
  font-weight: 400;
  margin: 0 0 var(--spacer-3) 0;
}

#body {
  margin: 0 0 var(--spacer-5) 0;
  color: var(--theme-tertiary-text);
  font-size: 0.875rem;
  line-height: 1.25rem;
  max-width: 340px;
}

.aha-empty-state__title {
  color: var(--theme-primary-text);
  font-size: 1.125rem !important;
  line-height: 1;
  font-weight: 400;
}

.aha-empty-state__icon {
  scale: 2;
  color: var(--theme-accent-text);
  margin-bottom: var(--spacer-3);
}
